import axios from 'axios'

export const putPromptOptInMarketingTexts = (data) => {
  return axios.put('/user/prompt-opt-in-marketing-texts', {
    ...data,
  })
}
